import { FC} from "react";
import * as Yup from "yup";
import {ActionTypeEnum, HasFormIdModel, RequestActionModel } from "../../models";
import {getLabelName, validateNoSpaces, validateRequired, yubCombineValidationsManager} from "../../utils";
import {useFormik} from "formik";
import {ButtonBox, LoadingBox, PrivilegesChecker, TextBox} from "..";
import {useUnitManager} from "../../hooks";

interface UnitRegistrationFormProps extends HasFormIdModel {
  onActionEvent?: (o: RequestActionModel) => Promise<void>;
}

/**
 * Form component for registering and updating units
 */
export const RegisterUnit: FC<UnitRegistrationFormProps> = ({
                                                                      formId,
                                                                      onActionEvent,
                                                                    }) => {

  //#region hooks
  const {
    loading,
    unit,
    initialValues,
    handleSubmitUnit,
    handleActions
  } = useUnitManager();
//#endregion
  //#region formik
  // Validation schema
  const validationSchema = Yup.object({
    Name: yubCombineValidationsManager([
      validateRequired(),
      validateNoSpaces(),
    ]),
    Name_En: yubCombineValidationsManager([validateNoSpaces()]),
  });
  // Initialize formik
  const formik = useFormik({
    initialValues: unit || initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true, // Important to re-initialize when unit changes
    onSubmit: async (values, {resetForm}) => {
      const success = await handleSubmitUnit(values);
      if (success) {
        resetForm();
      }
    },
    onReset: async () => {
      // Reset form completely
      await formik.setValues({...initialValues});
      await formik.setTouched({});
      formik.setErrors({});

      // Clear action
      //handleActions({action: ActionTypeEnum.Clear});
    },
  });
//#endregion
  //#region html
  // Form rendering
  return (
      <>
        {loading && <LoadingBox />}
        <form className="forms-sample" onSubmit={formik.handleSubmit}>
          <div className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-md-4 g-sm-4">
            <div className="col">
              <TextBox
                  labelName={getLabelName("Name")}
                  inputName="Name"
                  isMandatory={true}
                  inputValue={formik.values.Name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  errorText={formik.errors.Name}
              />
            </div>
            <div className="col">
              <TextBox
                  labelName={getLabelName("Eng Name")}
                  inputName="Name_En"
                  inputValue={formik.values.Name_En}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  errorText={formik.errors.Name_En}
              />
            </div>

            <div className="col d-flex align-items-end">
              <div className="me-3">
                <TextBox
                    key="IsDefault"
                    labelName="Is Default"
                    inputName="IsDefault"
                    type="checkbox"
                    inputValue={formik.values.IsDefault}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
              </div>

              <PrivilegesChecker
                  formId={formId}
                  action={unit && unit.ID ? "EnableUpdate" : "EnableSave"}
              >
                <ButtonBox
                    iconType="content-save"
                    type="submit"
                    className="btn-primary btn-sm mx-2"
                >
                  {getLabelName(unit && unit.ID ? "update" : "save")}
                </ButtonBox>
              </PrivilegesChecker>

              <ButtonBox
                  iconType="receipt"
                  variant="danger"
                  type="button"
                  className="btn-sm"
                  onClick={async () => {
                    formik.resetForm();
                    await handleActions({ action: ActionTypeEnum.Clear });
                  }}
              >
                {getLabelName("New")}
              </ButtonBox>
            </div>
          </div>
        </form>
      </>
  );


//#endregion
};


//export default UnitRegistrationForm;